import { render } from "./TemplateModalSite.vue?vue&type=template&id=47281869&ts=true"
import script from "./TemplateModalSite.vue?vue&type=script&lang=ts"
export * from "./TemplateModalSite.vue?vue&type=script&lang=ts"

import "./TemplateModalSite.vue?vue&type=style&index=0&id=47281869&lang=scss"

import exportComponent from "/var/my_garage_api_front/PROD/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBar,QSpace,QBtn,QCardSection});
